import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import PropTypes from "prop-types";

import MKBox from "components/MKBox";
import DefaultInfoCard from "reusables/Cards/InfoCards/DefaultInfoCard";
import SubTitleContents from "reusables/TextFormats/SubTitleContents";

import logo from "assets/images/Spechs_logo/logo_no_text_transparent.png";

function ServiceHighlights({ title, description, items }) {
  const rows = [];
  for (let i = 0; i < items.length; i += 2) {
    rows.push(items.slice(i, i + 2));
  }

  return (
    <Container>
      {title && <SubTitleContents title={title} contents={description} />}
      <Grid container item alignItems="center" sx={{ mx: "auto" }} width="100%" mt={title ? 10 : 0}>
        <Grid item xs={12} lg={3} pr={8} m={0}>
          <MKBox
            component="img"
            src={logo}
            alt="Spechs Logo"
            width="100%"
            opacity={0.2}
            position="relative"
            zIndex={1}
            sx={{ filter: "grayscale(100%)" }}
          />
        </Grid>
        <Grid item xs={12} lg={9} sx={{ ml: "auto" }}>
          {rows.map((row, rowIndex) => (
            <Grid
              container
              spacing={3}
              key={rowIndex}
              sx={{ mt: rowIndex === 0 ? 0 : { xs: 0, md: 6 } }}
            >
              {row.map(({ icon, title: cardTitle, description: cardDesc }) => (
                <Grid item xs={12} md={6} key={cardTitle}>
                  <DefaultInfoCard icon={icon} title={cardTitle} description={cardDesc} />
                </Grid>
              ))}
            </Grid>
          ))}
        </Grid>
      </Grid>
    </Container>
  );
}

ServiceHighlights.defaultProps = {
  title: null,
  description: null,
};

ServiceHighlights.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  items: PropTypes.arrayOf(
    PropTypes.shape({
      icon: PropTypes.string.isRequired,
      title: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    })
  ).isRequired,
};

export default ServiceHighlights;
